module.exports = __webpack_public_path__ + "static/media/gallery20.91d43ab4.jpeg";